import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Header from "@/component/header.vue"
import Footer from "@/component/footer.vue"

Vue.component('Header', Header);
Vue.component('Footer', Footer);
var VueScrollTo = require('vue-scrollto');

Vue.use(VueScrollTo)
Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  render: h => h(App)
}).$mount('#app')
